import $ from 'jquery'

$('.accordion-section-header').on('click', function () {
  $(this).parent().toggleClass('accordion-section--active')
  $(this).next().slideToggle()
})
